function addoncarttotal(){    
  var addontotal = 0;
  var checkaddonincart = 0;  
  $(".cart-table .cart-item").each(function(){
    var rowid = $(this).attr('id');
    var addontotalprice = 0;        
    if( ($(this).is(':contains("Exclusive Offer:")')) || ($(this).is(':contains("Needles & Tools:")'))){

      //alert(rowid);

      var splitval = $(this).find('span.item-property-value').text().split(',');
      var spliarray = [];

      $(this).find('span.item-property-value').each(function (i, e) {
        spliarray.push($(e).text());  
      });
      
      var quantity_val = $(this).find('.cart-item-quantity').val();        
      if(spliarray){
        $.each(spliarray,function(i){
          if (spliarray[i].includes('[')) {

            if (spliarray[i].includes(',')) {
              var multiaddon = spliarray[i].split(',')
                $.each(multiaddon,function(k){
                    if($('input[name="currency_code"]').val() == 'USD'){
                    	addontotalprice += parseFloat(multiaddon[k].split('[').pop().split(']')[0].replace('+$',''));
                    }else{
                    	addontotalprice += parseFloat(multiaddon[k].split('[').pop().split(']')[0].replace('+£',''));
                    }
                });
            } else {
              
              if($('input[name="currency_code"]').val() == 'USD'){
              	addontotalprice += parseFloat(spliarray[i].split('[').pop().split(']')[0].replace('+$',''));
              }else{
              	addontotalprice += parseFloat(spliarray[i].split('[').pop().split(']')[0].replace('+£',''));
              }  
              
            }
            console.log(parseFloat(spliarray[i].split('[').pop().split(']')[0].replace('+£','')));
          }
        });
      } else {
        //alert($(this).find('dd').text());
      }
      if($('input[name="currency_code"]').val() == 'USD'){
        var rowproductprice = parseFloat($('#'+ rowid +' .cart-item-column-total .cart-item-final-price').text().replace('$',''));
        rowproductprice += (addontotalprice * quantity_val);       
        $('#'+ rowid +' .cart-item-column-total .cart-item-final-price').text('$'+rowproductprice.toFixed(2));
      } else {       
        var rowproductprice = parseFloat($('#'+ rowid +' .cart-item-column-total .cart-item-final-price').text().replace('£',''));
        rowproductprice += (addontotalprice * quantity_val);       
        $('#'+ rowid +' .cart-item-column-total .cart-item-final-price').text('£'+rowproductprice.toFixed(2));        
      }

      //console.log(rowproductprice.toFixed(2));

      addontotal += (addontotalprice * quantity_val);
      
      // hide cart buy now button
      
      $('.cart .cart-tools .checkout .additional-checkout-buttons').hide();      
	  checkaddonincart = 1;
    }
  });
  
  if(checkaddonincart == 0){    
    $('.cart .cart-tools .checkout .action-button.cart-submit').removeClass('aod_checkout');
    $('.cart .cart-tools .checkout .additional-checkout-buttons').show();
  }  
  
  
  if(addontotal != 0){
    if($('input[name="currency_code"]').val() == 'USD'){
      var carttotal = parseFloat($('.cart-tools .totals .price .money').text().replace('$',''));
      carttotal += addontotal;
      $('.cart-tools .totals .price .money').text('$'+ carttotal.toFixed(2));    
    } else {
      var carttotal = parseFloat($('.cart-tools .totals .price .money').text().replace('£',''));
      carttotal += addontotal;
      $('.cart-tools .totals .price .money').text('£'+ carttotal.toFixed(2));
    }
  }
  
  //alert(carttotal);
  $('.preloader').hide();
}

function addonqunatityupdate(){
  $('.preloader').show();
  $('.cart-item-column-total .cart-item-final-price').css('visibility', 'hidden');
  setTimeout(function(){ addoncarttotal(); $('.cart-item-column-total .cart-item-final-price').css('visibility', 'vissble'); }, 2500);
}

function checkbuynowbutton(){
  
    setTimeout(function(){
      if ($('#aod_outer_option').is(':empty')){
         //$('.shopify-product-form .shopify-payment-button').removeClass('woolhidebtn');
      } else {
         $('.shopify-product-form .shopify-payment-button').addClass('woolhidebtn');
      }
    }, 2500);  
  
}

function productleftsticky() {
  var productdetailwrapht = $(".product-details-wrapper").height();
  //console.log(productdetailwrapht);
  //console.log(document.body.scrollTop);
  if (document.documentElement.scrollTop > 330 && document.documentElement.scrollTop < (productdetailwrapht + 200)) {
    $('.content.content-area .product-area').addClass('stickypanel');
  } else {
    $('.content.content-area .product-area').removeClass('stickypanel');    
  }
}

jQuery(function($) {   
  
  $(document).ready(function() {  

    $('.prod-desc .description h5').click(function() {
        $(this).toggleClass('active');
        $(this).next().slideToggle();
    });
    $('.prod-desc .description h5:first-child').trigger('click');
    
    // Append up and down arrows to the body or a specific container
    $('.product-gallery--navigation button:first-child').before('<span class="up-arrow" style="cursor: pointer;"><i class="fa fa-angle-up"></i></span>');
    $('.product-gallery--navigation').append('<span class="down-arrow" style="cursor: pointer;"><i class="fa fa-angle-down"></i></span>');
    
    // Style the arrows (optional, you can add this to your CSS file)
    $('.up-arrow, .down-arrow').css({
        'display': 'block',
        'position': 'sticky',
        'font-size': '20px',
        'bottom': '0',
        'text-align': 'center',
        'z-index': '100'
    });
    $('.up-arrow').css({
        'bottom': '100%',
        'top': '0'
    });
    
    // Handle the click event for the up arrow
    $('.up-arrow').click(function() {
        var scrollableDiv = $('.product-gallery--navigation');
        var currentScroll = scrollableDiv.scrollTop();
        scrollableDiv.animate({
            scrollTop: currentScroll - 240
        }, 300);
    });
    
    // Handle the click event for the down arrow
    $('.down-arrow').click(function() {
        var scrollableDiv = $('.product-gallery--navigation');
        var currentScroll = scrollableDiv.scrollTop();
        scrollableDiv.animate({
            scrollTop: currentScroll + 240
        }, 300);
    });
    
    
    //window.onscroll = function() { productleftsticky()};    
    
    if((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1 ){
    }
    else if(navigator.userAgent.indexOf("Chrome") != -1 ){     
    }
    else if(navigator.userAgent.indexOf("Safari") != -1){
      //alert('Safari');
      $(window).bind("pageshow", function(event) {
          if (event.originalEvent.persisted) {
              window.location.reload() 
          }
      });     
    }
    else if(navigator.userAgent.indexOf("Firefox") != -1 ){
      //alert('Firefox');
    }
    else if((navigator.userAgent.indexOf("MSIE") != -1 ) || (!!document.documentMode == true )){
      //alert('IE'); 
    }  
    else{
      //alert('Not so sure !!');
    } 
    
    
    var productgalleryheight = $(".product-gallery--viewport").height();
    //console.log(productgalleryheight);
    $(".product-gallery--navigation").css("max-height", productgalleryheight);
    
    $( window ).resize(function() {
        var productgalleryheight = $(".product-gallery--viewport").height();
        //console.log(productgalleryheight);
        $(".product-gallery--navigation").css("max-height", productgalleryheight);
    });    
    
    
    $('.aod_subtotal').hide();
    addoncarttotal(); // initialize 
    
    //checkbuynowbutton(); // check buy now button
    
    $(document).on("change", "#aod_outer_option input" , function() {
      //checkbuynowbutton();
      if(this.checked) {
        $('.shopify-product-form .shopify-payment-button').addClass('woolhidebtn');
      } else {
        $('.shopify-product-form .shopify-payment-button').removeClass('woolhidebtn');
      }
      
      $( ".aod_groupcheckbox" ).each(function() {
        if(this.checked) {
        	$('.shopify-product-form .shopify-payment-button').addClass('woolhidebtn');
      	}
      });      
      
      if($('ul.wl-wool-selectbox li.woolfilled').length != $('ul.wl-wool-selectbox li').length){
        $('.shopify-product-form .shopify-payment-button').addClass('woolhidebtn');
      }      
      
    });    
    
    $(".wl-wool-panel li span").click(function() {
         
        var pickcolor = $( this ).data( "wlname" );
        var pickbrand = $( this ).data( "wlbrand" );
        var pickcolorstyle = $( this ).attr( "style" );
        $( "ul.wl-wool-selectbox li" ).each(function( index ) {
          //console.log( index + ": " + $( this ).text() );
          if ($(this).hasClass('active')) {
            $('#'+$(this).data( "selectbox" )).val(pickcolor +' ('+ pickbrand + ')');
            //$('#'+$(this).data( "selectbox" )).prop('checked', true);
            $(this).children().children().first().attr( "style", pickcolorstyle);
            $(this).next().addClass('active');
            $(this).removeClass('active');
            $(this).addClass('woolfilled');
            return false;
          }
        });  
      
      	//$('ul.wl-wool-selectbox li.active').next().addClass('active');
        /*
      	var selectbox = $('ul.wl-wool-selectbox li.active').data( "selectbox" );
        //alert(selectbox);
        if(selectbox){
          	$('#'+selectbox).val(pickcolor);
			$('#'+selectbox).prop('checked', true);
        } */
      
      	var totalpickcolor = $('ul.wl-wool-selectbox li').length;
        var totalpickedcolor = $('ul.wl-wool-selectbox li.woolfilled').length;
        if(totalpickcolor == totalpickedcolor){
          $('.product-form .product-submit').removeClass('desaturated').removeClass('disabled').prop('disabled', false);
          $('.shopify-payment-button__button').removeClass('disabled').prop('disabled', false);
          $('.shopify-product-form .product-submit.action-button, .shopify-product-form .shopify-payment-button').removeClass('woolhidebtn');
        } else {
          $('.shopify-payment-button__button').addClass('disabled').prop('disabled', true);
          $('.shopify-product-form .product-submit.action-button, .shopify-product-form .shopify-payment-button').addClass('woolhidebtn');
        }
      
		/*
        if ($('#aod_outer_option').is(':empty')){
           //$('.shopify-product-form .shopify-payment-button').removeClass('woolhidebtn');
        } else {
           $('.shopify-product-form .shopify-payment-button').addClass('woolhidebtn');
        }*/
        $( ".aod_groupcheckbox" ).each(function() {
          if(this.checked) {
              $('.shopify-product-form .shopify-payment-button').addClass('woolhidebtn');
          }
        });      
      
    });

	
    $("ul.wl-wool-selectbox li").click(function() {
      	$( "ul.wl-wool-selectbox li" ).removeClass('active');
    	$(this).addClass('active');      
	});
    
	$(".clearall-selection").click(function() { 
      	$( ".wl-selectbox" ).val('');
    	$(".wl-wool-selectbox li span").attr( "style", '');
        $(".wl-wool-selectbox li").removeClass('active').removeClass('woolfilled');
        $(".wl-wool-selectbox li:first-child").addClass('active');
        $('.product-form .product-submit').prop('disabled', true).addClass('disabled');
        $('.shopify-payment-button__button').addClass('disabled').prop('disabled', true);
      	$('.shopify-product-form .product-submit.action-button, .shopify-product-form .shopify-payment-button').addClass('woolhidebtn');
	});  
        
    if(wl_total_options !== undefined){
      if(wl_total_options){  
        setTimeout(function(){ 
          //$('.shopify-payment-button__button').addClass('disabled').prop('disabled', true); 
          //$('.product-form .product-submit').prop('disabled', true).addClass('disabled');          
          //$('.shopify-product-form .product-submit.action-button, .shopify-product-form .shopify-payment-button').addClass('woolhidebtn');
        }, 1000);        
        $('.shopify-product-form .product-submit.action-button, .shopify-product-form .shopify-payment-button').addClass('woolhidebtn');        
      }
    }
       
   $('.product-submit').click(function(e) {     
      e.preventDefault(); 
     
      var wctotalpickcolor = $('ul.wl-wool-selectbox li').length;
      var wctotalpickedcolor = $('ul.wl-wool-selectbox li.woolfilled').length;
      if(wctotalpickcolor != wctotalpickedcolor){
          $('.product-form .product-submit').removeClass('desaturated').removeClass('disabled').prop('disabled', false);
          $('.shopify-payment-button__button').removeClass('disabled').prop('disabled', false);
      	  return false;
          e.stopPropagation();
      }
           
      $(this).prop('disabled', true);
      //$('.shopify-product-form .product-submit.action-button, .shopify-product-form .shopify-payment-button').hide();
   }); 
    
    $(".videomenu .videomenu_wrap span").click(function(){
       var videocat = $( this ).attr("class");
       $(".videomenu .videomenu_wrap span").removeClass('active');
	   $( this ).addClass("active");      
       $(".videocatlis_wrap").hide();
       $("#"+ videocat).show();
    });
    
    /* Load More video list */
    $(".videocatlist .loadmore").click(function(){
		  var loadcount = $( this ).data("count");
          var perclick = $( this ).data("perclick");
          var totalblk = $( this ).data("totalblk");
          var containername = $( this ).data("container");      
          loadcount = loadcount + perclick;
      	  $('#'+containername+' div.vlistinnerwrap:lt('+loadcount+')').show();
          $( this ).data("count", loadcount);
      
          if(loadcount > totalblk){
            $('#'+containername+' .loadmore').hide();
          }
    });

    /* Load More video list */
    $(".ls-button-search, .ls-button-search .ls-label").click(function(){
    	$('.live-search').removeClass(' live-search-hidden')
    });
    $(".ls-form-button-close  ").click(function(){
    	$('.live-search').addClass(' live-search-hidden')
    });    
    
    if(typeof noyarnpicker !== 'undefined' && noyarnpicker == 'noyarnpicker'){
        setTimeout(function(){ 
          $('.product-form .product-submit.disabled.addtocart-button-active').prop('disabled', false).removeClass('disabled'); 
        }, 1000);       
    }
    
  });  
});
  